<script>
import { defineComponent } from 'vue';
import AwaitingInvoiceItem from '@/components/consignment/awaitingInvoice/awaitingInvoiceItem.vue';
import ReturnMaterialModal from '@/components/consignment/awaitingInvoice/returnMaterialModal.vue'
import { useMeta } from 'quasar';

const metaData = {
  // sets document title
  title: 'Consignment: Awaiting Invoice',
  // optional; sets final title as "Index Page - My Website", useful for multiple level meta
  titleTemplate: title => `${title}`,
}

export default defineComponent({
    name: 'consignmentAwaitingInvoice',
    setup() {
      useMeta(metaData);
    },
    components: {
      AwaitingInvoiceItem,
      ReturnMaterialModal
    },
    computed: {
      used() {
        return this.$store.getters['consignment/used'];
      },
      isLoad() {
        return this.$store.getters['consignment/isLoad'];
      },
      accessToken() {
        return this.$store.getters['auth/accessToken'];
      },
      purchaseOrders() {
        try {
          let p = [];
          this.used.forEach(i => {
            if (!p.includes(i.purchaseOrderNumber)) {
              p.push(i.purchaseOrderNumber);
            }
          })

          return p;

        }catch(e){return []}
      },
      showLoading() {
          return this.$store.getters['consignment/onHandLoading'];
      },
      consignmentPermission() {
        return this.$store.getters['auth/consignmentPermission'];
      }
    },
    mounted() {
        if (this.consignmentPermission == "0") {
            this.$router.push('/');
        }
        if (!this.isLoad) {
          this.$store.dispatch('consignment/getConsignment', this.accessToken);
          this.$store.dispatch('consignment/getBillingStatus', this.accessToken);
        }
    },
})
</script>

<template>
<div style="height: 100%">
    <div class="mobileDiv"></div>
    <div v-if="purchaseOrders.length>0 && !showLoading">
      <q-scroll-area ref="scrollTargetRef" v-bind:style="{height: '100vh', maxWidth: '100%', paddingBottom: '50px'}">
        <q-list bordered>
            <awaiting-invoice-item v-for="(po, idx) in purchaseOrders" :key=idx :po=po :items="used.filter(i => i.purchaseOrderNumber==po)" :permission="consignmentPermission"></awaiting-invoice-item>
        </q-list>
      </q-scroll-area>
    </div>
    <div v-if="purchaseOrders.length==0 && !showLoading">
      <h6 class="wcwH text-center text-grey-7 q-pt-md">No Material Awaiting Invoice</h6>
    </div>


    <!-- MODALS -->
    <return-material-modal></return-material-modal>

</div>

</template>
